export default __webpack_public_path__ + "static/media/img-slider-smart-signage-4.c071ea81.png";